import SVG from 'react-inlinesvg';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import enhanceWithClickOutside from 'react-click-outside';

import caret from '../../../../../../assets/images/caret.svg';
import AnswerList from './answer_list';
import RichContentViewer from '../../../../../shared/components/rich/viewer';
import { answerShape, questionShape } from '../../../shapes/entities';

export class AnswerDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = { isActive: false };
    this.toggle = this.toggle.bind(this);
  }

  componentDidUpdate({ selected: prevSelected }) {
    if (prevSelected !== this.props.selected && !this.props.isMultipleChoice) {
      this.handleClickOutside();
    }
  }

  toggle() {
    this.setState(({ isActive }) => ({ isActive: !isActive }));
  }

  handleClickOutside() {
    this.setState({ isActive: false });
  }

  // Convert selected answers index to comma separated letters (0 = (A), 1 = (B), etc.)
  multipleChoiceLabel() {
    const { answers, selected: selectedIds } = this.props;

    return answers
      .map((answer, index) => {
        if (selectedIds.includes(answer.id)) {
          const letter = String.fromCharCode(65 + index);
          return `(${letter})`;
        }
        return null;
      })
      .filter(Boolean)
      .join(', ');
  }

  renderDropdownButton() {
    const { answers, selected: selectedIds, isReview } = this.props;

    if (selectedIds.length === 0) {
      return this.renderSelectedOption(
        'Bitte wähle...',
        classnames('t-padding-small--left', {})
      );
    }

    if (this.props.isMultipleChoice) {
      const label = this.multipleChoiceLabel();

      const correctIds = answers
        .filter(answer => answer.attributes.correct)
        .map(answer => answer.id.toString());

      const isCorrect = correctIds.every(correctId =>
        selectedIds.includes(correctId)
      );

      return this.renderSelectedOption(
        label,
        classnames('t-padding-small--left', {
          'is-correct': isReview && isCorrect,
          'is-incorrect': isReview && !isCorrect
        })
      );
    }

    // When not multiple choice, render all answers and hide the unselected ones
    return (
      <ul className="o-list-reset c-answer-list">
        {answers.map(answer => (
          <li
            key={answer.id}
            className={classnames('c-answer-list__item', {
              'o-visuallyhidden': !selectedIds.includes(answer.id)
            })}
          >
            {this.renderSelectedOption(
              <RichContentViewer content={answer.attributes.content} />,
              classnames('c-answer-list__answer', {
                'is-correct': isReview && answer.attributes.correct,
                'is-incorrect': isReview && !answer.attributes.correct
              })
            )}
          </li>
        ))}
      </ul>
    );
  }

  renderSelectedOption(label, className) {
    return (
      <button
        type="button"
        onClick={this.toggle}
        className={classnames('o-button o-button--answer', className)}
        aria-pressed={this.props.isReview}
      >
        <span className="l-flex l-flex--split l-flex--center t-gap">
          {label}

          <SVG
            src={caret}
            alt="dropdown caret"
            className="o-icon o-icon--small o-button__icon"
            width="16"
            height="16"
          />
        </span>
      </button>
    );
  }

  render() {
    const { isActive } = this.state;

    const {
      question: { id: questionId }
    } = this.props;

    const answerListProps = {
      ...this.props,
      wrapperClassNames: ''
    };

    const dropdownPanelClassName = classnames('c-dropdown__panel t-padding', {
      'c-dropdown--active': isActive
    });

    return (
      <div className="c-dropdown-wrapper">
        <div
          className={classnames(
            'c-dropdown',
            `qa-answer-dropdown-${questionId}`
          )}
        >
          {this.renderDropdownButton()}

          <div className={dropdownPanelClassName} hidden={!isActive}>
            <AnswerList {...answerListProps} />
          </div>
        </div>
      </div>
    );
  }
}

AnswerDropdown.propTypes = {
  answers: PropTypes.arrayOf(answerShape).isRequired,
  isReview: PropTypes.bool.isRequired,
  isMultipleChoice: PropTypes.bool.isRequired,
  selected: PropTypes.arrayOf(PropTypes.string).isRequired,
  question: questionShape.isRequired,
  onToggleAnswer: PropTypes.func.isRequired
};

export default enhanceWithClickOutside(AnswerDropdown);
